import React from 'react';

export default function AppsHeader({ children }) {
  return <header className="apps-hero">
    <div className="apps-title-row">
      <h1 className="page-title">Applications</h1>
    </div>
    {children}
  </header>;
}
